<script>
import 'normalize-css';

export default {};
</script>
<style src="./styles/typography.css" />
<style src="./styles/common.css" />

<template>
    <router-view>
    </router-view>
</template>



// WEBPACK FOOTER //
// src/body.vue?1d306c7d